<template>
  <live ref="live" :isMore="false" :isShowNav="true" :large="true" :moduleInfo="moduleInfo" :moduleFlag="moduleFlag" />
</template>

<script>
  import dataMixins from '@/mixins/pc/data'
  import live from '@/components/pc/live'

  export default {
    components: { live },
    mixins: [dataMixins],
    data() {
      return {
        moduleInfo: this.getModuleData(),
      }
    },
    methods: {},
    created() {
      console.log('this.moduleInfo', this.moduleInfo)
    }
  }
</script>

<style scoped lang="scss">
  .live {
    padding-bottom: 70px;
  }
</style>
